import React, { useState, useEffect } from "react";
import { Link, useLocation, Outlet } from "react-router-dom";
import "./css/About.scss";

// Components

import TitleBox from "../components/TitleBox";
import Footer from "../components/Footer";

const About = () => {
  const props = useLocation();

  const [height, setHeight] = useState(window.innerHeight);
  const [width, setWidth] = useState(window.innerWidth);
  const [index, setIndex] = useState(props.state ? props.state.index : 0);

  window.addEventListener("resize", function () {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  });

  useEffect(() => {
    switch (props.pathname) {
      case "/about":
        setIndex(0);
        break;
      case "/about/leadership/":
        setIndex(1);
        break;
      case "/about/leadership/board-of-directors":
        setIndex(1);
        break;
      case "/about/leadership/management":
        setIndex(1);
        break;
      case "/about/leadership/curriculum-vitae":
        setIndex(1);
        break;
      case "/about/committee":
        setIndex(2);
        break;
      case "/about/committee/audit-committee":
        setIndex(2);
        break;
      case "/about/committee/corporate-governance":
        setIndex(2);
        break;
      case "/about/committee/board-risk-oversight":
        setIndex(2);
        break;
      case "/about/committee/related-party-transactions":
        setIndex(2);
        break;
      case "/about/mission-and-vision":
        setIndex(3);
        break;
      case "/about/company-profile":
        setIndex(4);
        break;
      case "/about/company-policies":
        setIndex(5);
        break;
      case "/about/corporate-identity-and-values":
        setIndex(6);
        break;
      case "/about/certificate-of-authority":
        setIndex(7);
        break;
      case "/about/certificate-of-registration":
        setIndex(8);
        break;
      case "/about/branches":
        setIndex(9);
        break;
      default:
        setIndex(0);
        return;
    }
  }, [props.pathname]);

  return (
    <div
      className="about-container"
      style={{
        height: height - 75,
        width: width,
      }}
    >
      <TitleBox title={"About Us"} />
      <div className="about-us-selection">
        <div className="indexes">
          <ul className="selectors">
            <Link to={"/about"} onClick={() => setIndex(0)}>
              <li className={`list-item ${index === 0 ? "active" : ""}`}>
                About Us
              </li>
            </Link>
            <Link
              to={"./leadership/board-of-directors"}
              onClick={() => setIndex(1)}
            >
              <li className={`list-item ${index === 1 ? "active" : ""}`}>
                Leadership
              </li>
            </Link>
            <Link
              to={"./committee/audit-committee"}
              onClick={() => setIndex(2)}
            >
              <li className={`list-item ${index === 2 ? "active" : ""}`}>
                Committee
              </li>
            </Link>
            <Link to={"./mission-and-vision"} onClick={() => setIndex(3)}>
              <li className={`list-item ${index === 3 ? "active" : ""}`}>
                Mission and Vision
              </li>
            </Link>
            <Link to={"./company-profile"} onClick={() => setIndex(4)}>
              <li className={`list-item ${index === 4 ? "active" : ""}`}>
                Company Profile
              </li>
            </Link>
            <Link to={"./company-policies"} onClick={() => setIndex(5)}>
              <li className={`list-item ${index === 5 ? "active" : ""}`}>
                Company Policies
              </li>
            </Link>
            <Link
              to={"./corporate-identity-and-values"}
              onClick={() => setIndex(6)}
            >
              <li className={`list-item ${index === 6 ? "active" : ""}`}>
                Our Corporate Identity and Values
              </li>
            </Link>
            <Link to={"./certificate-of-authority"} onClick={() => setIndex(7)}>
              <li className={`list-item ${index === 7 ? "active" : ""}`}>
                Certificate of Authority
              </li>
            </Link>
            <Link
              to={"./certificate-of-registration"}
              onClick={() => setIndex(8)}
            >
              <li className={`list-item ${index === 8 ? "active" : ""}`}>
                Certificate of Registration
              </li>
            </Link>
            <Link to={"./branches"} onClick={() => setIndex(9)}>
              <li className={`list-item ${index === 9 ? "active" : ""}`}>
                Our Branches
              </li>
            </Link>
          </ul>
        </div>
        <div className="inner-container">
          <Outlet />
        </div>
      </div>
      <Footer
        args={{
          height,
          width,
          styles: {
            height: 50,
            width: width,
            position: "absolute",
            bottom: 0,
          },
        }}
      />
    </div>
  );
};

export default About;
